import React from 'react';
import { Spoiler } from '@mantine/core';
import g1 from '../assets/images/2017/1.jpg';
import g2 from '../assets/images/2017/2.jpg';
import g3 from '../assets/images/2017/3.jpg';
import g4 from '../assets/images/2017/4.jpg';
import g5 from '../assets/images/2017/5.jpg';
import g6 from '../assets/images/2017/6.jpg';
import g7 from '../assets/images/2017/7.jpg';
import g8 from '../assets/images/2017/8.jpg';
import g9 from '../assets/images/2017/9.jpg';
import g10 from '../assets/images/2017/10.jpg';
import g11 from '../assets/images/2017/11.jpg';
import g12 from '../assets/images/2017/12.jpg';
import g13 from '../assets/images/2017/13.jpg';
import g14 from '../assets/images/2017/14.jpg';
import g15 from '../assets/images/2017/15.jpg';
import g16 from '../assets/images/2017/16.jpg';
import g17 from '../assets/images/2017/17.jpg';
import g18 from '../assets/images/2017/18.jpg';
import g19 from '../assets/images/2017/19.jpg';
import gallery1 from '../assets/images/gallery-1-1.jpg';
import gallery2 from '../assets/images/gallery-1-2.jpg';
import gallery3 from '../assets/images/gallery-1-3.jpg';
import gallery4 from '../assets/images/gallery-1-4.jpg';
import gallery5 from '../assets/images/gallery-1-5.jpg';
import gallery6 from '../assets/images/gallery-1-6.jpg';
import gallery7 from '../assets/images/gallery-1-7.jpg';
import gallery8 from '../assets/images/gallery-1-8.jpg';
import gallery9 from '../assets/images/gallery-1-9.jpg';

const Gallery = () => {
  return (
    <section className='gallery-one'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='course-details__top-left'>
              <h2 className='course-details__title'>2017</h2>
            </div>
          </div>
          <Spoiler maxHeight={280} hideLabel='Hide' showLabel='Show More'>
            <div className='row'>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g1} alt='' />
              <a href={g1} className='gallery-one__popup img-popup'>
                A&E Laboratory
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g2} alt='' />
              <a href={g2} className='gallery-one__popup img-popup'>
                A&E Laboratory
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g3} alt='' />
              <a href={g3} className='gallery-one__popup img-popup'>
                Modular Theatre
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g4} alt='' />
              <a href={g4} className='gallery-one__popup img-popup'>
                Modular Theatre
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g5} alt='' />
              <a href={g5} className='gallery-one__popup img-popup'>
                Modular Theatre
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g6} alt='' />
              <a href={g6} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g7} alt='' />
              <a href={g7} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g8} alt='' />
              <a href={g8} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g9} alt='' />
              <a href={g9} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g10} alt='' />
              <a href={g10} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g11} alt='' />
              <a href={g11} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g12} alt='' />
              <a href={g12} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g13} alt='' />
              <a href={g13} className='gallery-one__popup img-popup'>
                Open Heart Surgery by LUTH TEAM & Indian Surgeon
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g14} alt='' />
              <a href={g14} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g14} alt='' />
              <a href={g14} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single' style={{ height: 248 }}>
              <img src={g15} alt='' />
              <a href={g15} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g16} alt='' />
              <a href={g16} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g17} alt='' />
              <a href={g17} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g18} alt='' />
              <a href={g18} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          <div className='col-lg-4 col-md-6'>
            <div className='gallery-one__single'>
              <img src={g19} alt='' />
              <a href={g19} className='gallery-one__popup img-popup'>
                Vice President Visit to LUTH
                {/* <i className="kipso-icon-plus-symbol"></i> */}
              </a>
            </div>
          </div>
          </div>
          </Spoiler>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
